(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-coffee"] && !Shopify.designMode) return;
  try {
    
  function initializeCoffeeFinders(scope = document) {
    scope.querySelectorAll('[data-find-your-coffee]').forEach((finder) => {
      if (finder.dataset.initialized === 'true') return;
      finder.dataset.initialized = 'true';
      finder.classList.add('fyf--enhanced');

      const form = finder.querySelector('[data-fyf-form]');
      const steps = Array.from(finder.querySelectorAll('[data-fyf-step]'));
      const next = finder.querySelector('[data-fyf-next]');
      const back = finder.querySelector('[data-fyf-back]');
      const submit = finder.querySelector('[data-fyf-submit]');
      const reset = finder.querySelector('[data-fyf-reset]');
      const progress = finder.querySelector('[data-fyf-progress]');
      const progressBar = finder.querySelector('[data-fyf-progress-bar]');
      const grid = finder.querySelector('[data-fyf-grid]');
      const products = Array.from(finder.querySelectorAll('[data-fyf-product]'));
      let currentStep = 0;

      const showStep = (index) => {
        currentStep = index;
        steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
        back.hidden = index === 0;
        next.hidden = index === steps.length - 1;
        submit.hidden = index !== steps.length - 1;
        progress.textContent = `${finder.dataset.questionLabel} ${index + 1} ${finder.dataset.ofLabel} ${steps.length}`;
        progressBar.style.transform = `scaleX(${(index + 1) / steps.length})`;
        steps[index].querySelector('legend').focus?.();
      };

      const selectedValue = (prefix) => form.querySelector(`input[name^="${prefix}"]:checked`)?.value;

      next.addEventListener('click', () => {
        const checked = steps[currentStep].querySelector('input:checked');
        if (!checked) {
          steps[currentStep].querySelector('input').reportValidity();
          return;
        }
        showStep(Math.min(currentStep + 1, steps.length - 1));
      });

      back.addEventListener('click', () => showStep(Math.max(currentStep - 1, 0)));

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;

        const comfort = Number(selectedValue('comfort-'));
        const flavor = selectedValue('flavor-');
        const brew = selectedValue('brew-');
        const flavorTargets = flavor === 'any' ? [] : flavor.split('|');

        const ranked = products.map((product) => {
          const adventure = Number(product.dataset.adventure);
          const flavors = product.dataset.flavors.split('|');
          const methods = product.dataset.methods.split('|');
          const flavorMatch = flavorTargets.length === 0 || flavorTargets.some((target) => flavors.includes(target));
          const brewMatch = methods.includes(brew);
          let score = 10 - Math.abs(adventure - comfort) * 2;
          if (flavorMatch) score += 6;
          if (brewMatch) score += 5;
          return { product, score, flavorMatch, brewMatch };
        }).sort((a, b) => b.score - a.score);

        products.forEach((product) => product.classList.remove('fyf__product--match'));
        ranked.slice(0, 3).forEach((match, index) => {
          match.product.classList.add('fyf__product--match');
          match.product.querySelector('[data-fyf-badge]').textContent = index === 0 ? finder.dataset.bestMatch : finder.dataset.goodMatch;
          let reason = finder.dataset.reasonNear;
          if (match.flavorMatch && match.brewMatch) reason = finder.dataset.reasonBoth;
          else if (match.flavorMatch) reason = finder.dataset.reasonFlavor;
          else if (match.brewMatch) reason = finder.dataset.reasonBrew;
          match.product.querySelector('[data-fyf-why]').textContent = reason;
          grid.appendChild(match.product);
        });

        finder.classList.add('fyf--complete');
        finder.querySelector('[data-fyf-results]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      reset.addEventListener('click', () => {
        form.reset();
        finder.classList.remove('fyf--complete');
        products.forEach((product) => product.classList.remove('fyf__product--match'));
        showStep(0);
        finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      showStep(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCoffeeFinders());
  } else {
    initializeCoffeeFinders();
  }
  document.addEventListener('shopify:section:load', (event) => initializeCoffeeFinders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foster-rewards-overview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('foster-tier-explorer')) {
  customElements.define('foster-tier-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
        this.dispatchEvent(new CustomEvent('foster:tier-selected', { bubbles: true, detail: { tier: tab.querySelector('.fr-tier-name')?.textContent.trim() || 'unknown' } }));
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            select(tabs[next], true);
          }
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) select(tab);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
